import { GovernmentPortalWorkPage } from "@/components/non_registrant/government-portal-pages";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/government/cases")({
  component: GovernmentPortalWorkPage,
});
